import { Pipe, PipeTransform } from '@angular/core';
import { ReportStatus } from '@common/enums';

@Pipe({
  name: 'backupStatus',
  pure: true
})
export class BackupStatusPipe implements PipeTransform {
  private static readonly iconMap: Partial<Record<ReportStatus, string>> = {
    [ReportStatus.Issue]: 'fa fa-exclamation-circle',
    [ReportStatus.Overdue]: 'fa fa-clock-o',
    [ReportStatus.Warning]: 'fa fa-exclamation-triangle',
    [ReportStatus.Success]: 'fa fa-check-circle'
  };

  private static readonly typeMap: Partial<Record<ReportStatus, string>> = {
    [ReportStatus.Issue]: 'danger',
    [ReportStatus.Overdue]: 'yellow',
    [ReportStatus.Warning]: 'warning',
    [ReportStatus.Success]: 'success'
  };

  transform(status: ReportStatus, param: 'icon' | 'type' = 'icon'): any {
    if (!status) return '';

    switch (param) {
      case 'icon':
        return BackupStatusPipe.iconMap[status] || '';
      case 'type':
        return BackupStatusPipe.typeMap[status] || '';
      default:
        throw new Error(`Caught error manually: Unknown param in BackupStatusPipe: ${param}`);
    }
  }
}
